import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Grid, Link } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from 'jwt-decode';
//import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';


const Login = () => {
    //const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateInputs(formData)) {
            toast.error('Please fill in all fields correctly.');
            return;
        }

        try {
            await axios.post('https://5000-amirsa5-erpproject-b9c0ctsagqx.ws-eu106.gitpod.io/api/users/login', formData)
                .then((response) => {
                    toast.success('Login successful!');
                    const { token } = response.data;

                    // Set token in local storage
                    localStorage.setItem('token', token);
                    // Decode token to get user data
                    const decoded = jwtDecode(token);
                    const userId = decoded.userId;
                    // Redirect to dashboard
                    //navigate(`/admin-dashboard/${userId}`);
                    //window.history.go(`/admin-dashboard/${userId}`)
                    window.location.href = `/admin-dashboard/${userId}`

                })

            // Redirect to dashboard or perform necessary actions upon successful login
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                toast.error('Error logging in: ' + error.response.data.message);
            }
            else {
                toast.error('Error logging in: ' + error.message);
            }
        }
    };


    const validateInputs = (data) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return (
            data.email.trim() !== '' &&
            data.password.trim() !== '' &&
            emailRegex.test(data.email) // Validate email format
        );
    };

    return (
        <Container maxWidth="sm" className="form-container">
            <Typography variant="h4" gutterBottom align="center">
                User Login
            </Typography>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Email"
                            fullWidth
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Password"
                            type="password"
                            fullWidth
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Login
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Link>
                            <NavLink to="/forgot-password">
                                Forgot Password?
                            </NavLink>
                        </Link>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

export default Login;
